function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlhintSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_htmlhint") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.04 18.875 2.049 14.759 2.049 13.228 10.04 9.111 10.04 11.492 5.052 13.993 10.04 16.493 10.04 18.875",
    style: {
      fill: "#e44f26"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.313 19.07 15.03 19.07 19.573 7.267 21.872 7.267 17.313 19.07",
    style: {
      fill: "#e44f26"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.96 18.872 21.96 16.492 26.983 13.993 21.96 11.494 21.96 9.113 29.951 13.212 29.951 14.774 21.96 18.872",
    style: {
      fill: "#e44f26"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.633 24.733 10.967 23.068 9.3 24.732 7.622 23.066 5.947 24.731 4.274 23.066 3.2 24.134 2 23.347 4.274 21.082 5.947 22.749 7.622 21.084 9.297 22.749 10.967 21.081 12.636 22.747 14.303 21.084 15.982 22.75 17.656 21.082 19.331 22.75 21.011 21.085 22.686 22.75 24.366 21.084 26.039 22.75 27.718 21.086 30 23.344 28.802 24.136 27.718 23.063 26.035 24.73 24.364 23.066 22.685 24.73 21.009 23.064 19.328 24.73 17.656 23.066 15.983 24.73 14.306 23.066 12.633 24.733",
    style: {
      fill: "#c1272d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlhintSvgrepoCom);
export default __webpack_public_path__ + "static/media/htmlhint-svgrepo-com.806fb689cb50a67112431ae24f0d2bbc.svg";
export { ForwardRef as ReactComponent };